var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowRight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8.754,
  height: 14.169,
  viewBox: "0 0 8.754 14.169",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#656565;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12.123,131.779l-6.241-6.241a.771.771,0,0,1,0-1.09l.728-.728a.771.771,0,0,1,1.089,0l4.969,4.946,4.969-4.946a.771.771,0,0,1,1.089,0l.728.728a.771.771,0,0,1,0,1.09l-6.241,6.241a.771.771,0,0,1-1.09,0Z",
  transform: "matrix(0.017, -1, 1, 0.017, -123.574, 17.521)"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-right.8cd523be.svg";
export { ForwardRef as ReactComponent };